import { Alert } from "@mui/material";

type ChatAlertProps = {
    chatInfo: string | null | undefined;
    severity: 'error' | 'warning' | 'info' | 'success';
    onClose: () => void;
}

const ChatAlert: React.FC<ChatAlertProps> = ({ chatInfo, severity, onClose }) => {
    if (!chatInfo) {
        return null;
    }
    return (
        <Alert severity={severity} variant="filled" onClose={onClose} sx={{ borderRadius: 0 }}>{chatInfo}</Alert>
    )
};

export default ChatAlert;